document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mhb-hero').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('.mhb-hero__slide'));
    const dots = Array.from(hero.querySelectorAll('.mhb-hero__dots button'));

    if (!slides.length) return;

    let activeIndex = 0;

    function goToSlide(index) {
      slides[activeIndex].classList.remove('is-active');
      if (dots[activeIndex]) dots[activeIndex].classList.remove('is-active');

      activeIndex = index;

      slides[activeIndex].classList.add('is-active');
      if (dots[activeIndex]) dots[activeIndex].classList.add('is-active');
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goToSlide(Number(dot.dataset.slideIndex));
      });
    });
  });
});